(function () {
  'use strict';

  function initializeMobileMenuSearch() {
    var drawer = document.getElementById('MenuDrawer');
    if (!drawer || drawer.getAttribute('data-mobile-search-initialized') === 'true') return;

    var form = drawer.querySelector('.rp-mdrawer__search');
    var input = drawer.querySelector('.rp-mdrawer__search-input');
    var results = drawer.querySelector('[data-mobile-menu-search-results]');
    var status = drawer.querySelector('[data-mobile-menu-search-status]');
    var content = drawer.querySelector('[data-mobile-menu-search-content]');
    var viewAll = drawer.querySelector('[data-mobile-menu-search-view-all]');
    var drawerBody = drawer.querySelector('.Drawer__Body');

    if (!form || !input || !results || !status || !content || !viewAll) return;

    drawer.setAttribute('data-mobile-search-initialized', 'true');

    var predictiveSearchUrl = drawer.getAttribute('data-predictive-search-url') || '/search/suggest';
    var searchUrl = drawer.getAttribute('data-search-url') || '/search';
    var debounceTimer;
    var requestController;
    var requestNumber = 0;
    var wasExpanded = drawer.getAttribute('aria-hidden') === 'false' || drawer.classList.contains('Show');

    function setPanelAccessibility(searchIsActive) {
      drawer.querySelectorAll('[data-menu-panel]').forEach(function (panel) {
        var panelIsActive = panel.classList.contains('is-active');
        panel.setAttribute('aria-hidden', searchIsActive || !panelIsActive ? 'true' : 'false');
        panel.inert = searchIsActive || !panelIsActive;
      });
    }

    function setSearchMode(active) {
      drawer.classList.toggle('is-search-active', active);
      results.hidden = !active;
      setPanelAccessibility(active);
      if (drawerBody) drawerBody.scrollTop = 0;
    }

    function hideSearchResults() {
      window.clearTimeout(debounceTimer);
      requestNumber += 1;
      if (requestController) requestController.abort();
      requestController = null;
      content.replaceChildren();
      status.textContent = '';
      results.setAttribute('aria-busy', 'false');
      viewAll.hidden = true;
      setSearchMode(false);
    }

    function resetSearch() {
      input.value = '';
      hideSearchResults();
    }

    function safeLinkUrl(value) {
      try {
        var url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin) return '#';
        return url.pathname + url.search + url.hash;
      } catch (error) {
        return '#';
      }
    }

    function safeImageUrl(value) {
      if (!value) return '';

      try {
        var url = new URL(value, window.location.origin);
        return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : '';
      } catch (error) {
        return '';
      }
    }

    function getImage(item) {
      var image = item.featured_image || item.image;
      if (typeof image === 'string') return { url: image, alt: item.title || '' };
      if (!image) return null;
      return { url: image.url || image.src || '', alt: image.alt || item.title || '' };
    }

    function createResult(item, kind) {
      var listItem = document.createElement('li');
      var link = document.createElement('a');
      var image = getImage(item);
      var imageUrl = image ? safeImageUrl(image.url) : '';
      var meta = document.createElement('span');
      var title = document.createElement('span');
      var detail = document.createElement('span');

      link.className = 'rp-mobile-search__link';
      link.href = safeLinkUrl(item.url || '#');

      if (imageUrl) {
        var imageElement = document.createElement('img');
        imageElement.className = 'rp-mobile-search__image';
        imageElement.src = imageUrl;
        imageElement.alt = image.alt || '';
        imageElement.width = 48;
        imageElement.height = 48;
        imageElement.loading = 'lazy';
        link.appendChild(imageElement);
      }

      meta.className = 'rp-mobile-search__meta';
      title.className = 'rp-mobile-search__title';
      title.textContent = item.title || '';
      detail.className = 'rp-mobile-search__detail';
      detail.textContent = kind === 'Products' && item.price ? item.price : kind.slice(0, -1);

      meta.appendChild(title);
      meta.appendChild(detail);
      link.appendChild(meta);
      listItem.appendChild(link);
      return listItem;
    }

    function appendResultsSection(headingText, items) {
      if (!items.length) return;

      var section = document.createElement('section');
      var heading = document.createElement('h3');
      var list = document.createElement('ul');

      section.className = 'rp-mobile-search__section';
      heading.className = 'rp-mobile-search__heading';
      heading.textContent = headingText;
      list.className = 'rp-mobile-search__list';

      items.forEach(function (item) {
        list.appendChild(createResult(item, headingText));
      });

      section.appendChild(heading);
      section.appendChild(list);
      content.appendChild(section);
    }

    function renderResults(response, term) {
      var resourceResults = response && response.resources && response.resources.results
        ? response.resources.results
        : {};
      var products = Array.isArray(resourceResults.products) ? resourceResults.products.slice(0, 6) : [];
      var collections = Array.isArray(resourceResults.collections) ? resourceResults.collections.slice(0, 4) : [];
      var resultCount = products.length + collections.length;

      content.replaceChildren();
      appendResultsSection('Products', products);
      appendResultsSection('Collections', collections);

      if (resultCount) {
        status.textContent = resultCount + (resultCount === 1 ? ' suggestion' : ' suggestions') + ' for “' + term + '”';
        viewAll.href = searchUrl + '?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last&type=product';
        viewAll.hidden = false;
      } else {
        status.textContent = 'No results found for “' + term + '”';
        viewAll.hidden = true;
      }
    }

    function requestResults(term) {
      var currentRequest = ++requestNumber;
      var controller = window.AbortController ? new AbortController() : null;
      var endpoint = new URL(predictiveSearchUrl, window.location.origin);

      if (requestController) requestController.abort();
      requestController = controller;

      endpoint.pathname = endpoint.pathname.replace(/\.json$/, '') + '.json';
      endpoint.search = '';
      endpoint.searchParams.set('q', term);
      endpoint.searchParams.set('resources[type]', 'product,collection');
      endpoint.searchParams.set('resources[limit]', '10');
      endpoint.searchParams.set('resources[options][unavailable_products]', 'last');

      status.textContent = 'Searching…';
      content.replaceChildren();
      viewAll.hidden = true;
      results.setAttribute('aria-busy', 'true');

      fetch(endpoint.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: controller ? controller.signal : undefined
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search request failed');
          return response.json();
        })
        .then(function (response) {
          if (currentRequest !== requestNumber) return;
          renderResults(response, term);
        })
        .catch(function (error) {
          if (error.name === 'AbortError' || currentRequest !== requestNumber) return;
          content.replaceChildren();
          status.textContent = 'Search suggestions are unavailable. Press Enter to search.';
          viewAll.hidden = true;
        })
        .finally(function () {
          if (currentRequest === requestNumber) results.setAttribute('aria-busy', 'false');
        });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      window.clearTimeout(debounceTimer);

      if (!term) {
        hideSearchResults();
        return;
      }

      setSearchMode(true);
      content.replaceChildren();
      viewAll.hidden = true;

      if (term.length < 2) {
        status.textContent = 'Type at least 2 characters to search.';
        results.setAttribute('aria-busy', 'false');
        return;
      }

      status.textContent = 'Searching…';
      debounceTimer = window.setTimeout(function () { requestResults(term); }, 200);
    });

    form.addEventListener('submit', function (event) {
      if (!input.value.trim()) event.preventDefault();
    });

    new MutationObserver(function () {
      var expanded = drawer.getAttribute('aria-hidden') === 'false' || drawer.classList.contains('Show');
      if (!expanded && wasExpanded) resetSearch();
      wasExpanded = expanded;
    }).observe(drawer, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMobileMenuSearch, { once: true });
  } else {
    initializeMobileMenuSearch();
  }
})();
